import { ChatBubbleOutline } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import type { EmptyStateIndicatorProps } from 'stream-chat-react';
import { useTranslation } from 'react-i18next';

export default function ChatEmptyState({ listType }: EmptyStateIndicatorProps) {
  const { t } = useTranslation();

  if (listType !== 'channel' && listType !== 'message') {
    return null;
  }

  return (
    <Box
      data-qa-element-id="chat-empty-state"
      data-testid="chat-empty-state"
      sx={{
        display: 'flex',
        flex: 1,
        minHeight: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        textAlign: 'center',
      }}
    >
      <ChatBubbleOutline
        aria-hidden="true"
        sx={{
          flex: 'none',
          color: 'grey.400',
          fontSize: '6rem',
        }}
      />
      <Typography sx={{ color: 'text.secondary' }} variant="h6">
        {t('chat.nothingToShow')}
      </Typography>
    </Box>
  );
}
